import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLongRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10 4L14 8L10 12",
		stroke: "white",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1 8L14 8",
		stroke: "white",
		strokeWidth: 1.5
	})]
});
export default SvgArrowLongRight;
